import type { GetMinMaxAndAllowablesResult } from 'src/app/v1/views/components/Pay/util/getMinMaxAndAllowables';

import type { SalaryError } from './types';

export const minMaxErrorPredicate = (
  error: SalaryError,
  {
    minimum,
    maximum,
    allowableMin,
    allowableMax,
  }: Pick<
    GetMinMaxAndAllowablesResult,
    'minimum' | 'maximum' | 'allowableMax' | 'allowableMin'
  >,
  salaryErrorMin?: string | null,
  salaryErrorMax?: string | null,
) => {
  const result =
    !error.min &&
    !error.max &&
    !salaryErrorMin &&
    !salaryErrorMax &&
    (minimum < allowableMin || maximum > allowableMax);
  return result;
};
